import { Input, typographyV2 } from '@toggle/design-system';
import styled from 'styled-components';

export const StyledInput = styled(Input)`
  ${typographyV2.bodyBase};
`;
